import React from 'react';
import { useState, useContext, useEffect } from 'react';
import { ToolbarContext } from '../../contexts/toolbar-context';
import { currentWeek } from '../../utils';
import { format, addDays } from 'date-fns';
import {DistributorSelect} from "../../components/MaterialSelects/DistributorSelect";
import {BoroughSelect} from "../../components/MaterialSelects/BoroughSelect";
import {WeekSelect} from "../../components/WeekSelect";
import {RegionSelectGrouped} from "../../components/MaterialSelects/RegionSelectGrouped";
import {Accordion, AccordionActions, AccordionDetails, AccordionSummary, Button, FormControlLabel, Switch} from "@mui/material";
import {useDaybookContext} from "../../contexts/Daybook/DayBookContext";
import {useSnackbar} from "notistack";
import {useJobSheetReportMutation} from "../../generated/graphql";

const JobSheet = () => {
    const [dateValue, setDateValue] = useState(addDays(currentWeek(),7));
    const [showNewOnly, setShowNewOnly] = useState(true);
    const [isWait, setWait] = useState(false);
    const {enqueueSnackbar} = useSnackbar();
    const daybook =useDaybookContext();
    const url = daybook?.baseUrl + 'reports/job-list/';
    // + dateValue + '/1';
    
    const [mutation] = useJobSheetReportMutation({ fetchPolicy: 'no-cache' });
    const [regionType,setRegionType] = useState(null);
    const [region,setRegion] = useState(null);
    const [distributor,setDistributor] = useState(null);
    const [boroughs,setBoroughs] = useState([]);
    const handleSwitchChange = (event) => {
        setShowNewOnly(event.target.checked);
      };
    function changeDistributor(evt) {
        setDistributor(evt.target.value);
    }
    function changeRegion(evt) {
        setRegion(evt.target.value);
    }
    function changeRegionType(evt) {
        setRegionType(evt.target.value);
    }
    function changeDateValue(evt) {
        setDateValue(evt.target.value);
    }
    function changeBoroughs(evt) {
        setBoroughs(evt.target.value?[...evt.target.value]:[]);
    }
    const toolbarContext = useContext(ToolbarContext);
    useEffect(() => {
        toolbarContext.setPrimary(
          {
            primary: [],
            title: 'Weekly Job Sheet'
          });
      }, []);
    async function submitForm() {
        if((!distributor || !distributor.id) && (!region || !region.id) && (!regionType || !regionType.id) && (!boroughs.length)) {
            enqueueSnackbar('Please select a distributor, region or region type for this report.',{color:'error'});
            return;
        }
        if (isWait) return;
        enqueueSnackbar('Generating report');
        setWait(true);
        try {
            const bIds = boroughs.map((v) => {
                return v.id;
            });
            console.log('bids',bIds);
            // regionType: (regionType?.id ? regionType.id : null),
            const data = await mutation({
                variables: {
                    landscape: true, date: format(dateValue, 'yyyy-MM-dd'), regionId: (region?.id ? region.id : null),
                    distributorId: distributor?.id, boroughs: bIds, isNew: showNewOnly
                }
            });
            setWait(false);
            enqueueSnackbar('Rendering file',{color:'success'});
            const res = await fetch(data.data.jobSheetReport.reportData);
            const blobContent = await res.blob();
            const blobUrl = URL.createObjectURL(blobContent);
            window.open(blobUrl);
        } catch (e) {
            enqueueSnackbar('Rendering file',{color:'error'});
            setWait(false);
        }
    }
    /*<FormGroup label="Region Type" className="flex-full">
    <RegionSelectGrouped allowBlank={true} name="regionType" value={regionType} onChange={changeRegionType}/>
    </FormGroup>*/
    return (<Accordion defaultExpanded={true}>
        <AccordionSummary>Weekly Job Sheet</AccordionSummary>
        <AccordionDetails>
            <form action={url} method="POST" target="_blank">
                <div className="grid12">
                    {/*<RegionTypeSelect allowBlank={true} name="regionType" value={regionType} onChange={changeRegionType} label="Region Type" className="flex-full"/>*/}
                    <RegionSelectGrouped panelOnly={true} allowBlank={true} name="region" value={region} onChange={changeRegion} label="Region" className="flex-full"/>
                    <BoroughSelect fill={true} panelOnly={true} allowBlank={true} name="boroughs" value={boroughs} multiple={true} onChange={changeBoroughs} label="Boroughs"/>
                    <DistributorSelect label="Distributor" allowBlank={true} fill={false} name="distributor" value={distributor} onChange={changeDistributor} className="flex-full"/>
                    <WeekSelect onChange={changeDateValue} value={dateValue} label="Date" className="flex-full"/>
                </div>
            </form>
        </AccordionDetails>
        <AccordionActions>
            <FormControlLabel
                control={<Switch checked={showNewOnly} onChange={handleSwitchChange} />}
                label="Show New Only"
            />            
            <Button variant="contained" onClick={submitForm}>Generate Report</Button>
        </AccordionActions>
    </Accordion>);
}

export default JobSheet;